import { render, staticRenderFns } from "./WhatsappHome.vue?vue&type=template&id=2ff640bb"
import script from "./WhatsappHome.vue?vue&type=script&lang=js"
export * from "./WhatsappHome.vue?vue&type=script&lang=js"
import style0 from "./WhatsappHome.vue?vue&type=style&index=0&id=2ff640bb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports